<template>
  <div>
    <d-form-row class="form-group">
      <d-col cols="12" class="mb-3">
        <label class="d-flex align-items-center">
          Escolha um jogo:
          <a
            :href="`${crosswordUrl}admin/gerador/criptogramas/novo`"
            target="_blank"
            class="p-1 ml-3 btn-outline-info btn-sm"
          >
            Criar novo jogo no sistema
          </a>
        </label>
        <autocomplete
          ref="cryptogram_search"
          placeholder="Buscar criptogramas"
          :items="puzzles"
          item-show="name"
          :on-input="onInputPuzzle"
          :on-select="setPuzzle"
        />
      </d-col>
    </d-form-row>
    <d-form-row v-if="model.data.name">
      <d-col cols="12">
        <h5>{{ model.data.name }}</h5>
      </d-col>
    </d-form-row>
    <div class="px-1 pb-1 d-flex overflow-auto" v-if="model.data.settings">
      <div
        :class="[
          'cryptogram-theme-default mt-4 position-relative mx-auto',
          {
            'cryptogram-theme-radius':
              model.data.settings.cryptogramTheme === 'radius',
            'cryptogram-theme-molotov':
              model.data.settings.cryptogramTheme === 'molotov',
          },
        ]"
        :style="{
          'grid-template-rows': `repeat(${model.data.rows}, ${cellSize}px)`,
          'grid-template-columns': `350px repeat(${model.data.columns -
            1}, ${cellSize}px)`
        }"
      >
        <cryptogram-cell
          v-for="(cell, index) in model.data.table"
          ref="cryptogramCell"
          :key="index"
          :cell="cell"
          :data-index="index"
          :font="model.data.settings.cryptogramFont"
        />
      </div>
    </div>
    <modal-login />
  </div>
</template>

<script>
import { cloneDeep } from '_utils';
import { mapActions } from 'vuex';
import config from '_config';
import Autocomplete from '_shared/Autocomplete.vue';
import CrosswordsService from '_services/rest/modules/crossword';
import ModalLogin from '../LoginModal.vue';
import CryptogramCell from './CryptogramCell.vue';
import { MODEL } from './CryptogramModel';

const data = {
  name: '',
  rows: 1,
  table: [],
  columns: 1,
  settings: {
    cryptogramFont: null,
    cryptogramTheme: 'default',
  },
};
const PUZZLE = { ...MODEL, ...{ data } };

export default {
  name: 'Cryptogram-puzzle',
  components: {
    Autocomplete,
    CryptogramCell,
    ModalLogin,
  },
  props: {
    model: {
      type: Object,
      require: true,
      default: () => cloneDeep(PUZZLE),
    },
  },
  data() {
    return {
      puzzles: [],
    };
  },
  computed: {
    crosswordUrl() {
      return config.FRONT_CROSSWORD_URL;
    },
    cellSize() {
      return this.isMobile ? 50 : 70;
    },
    isMobile() {
      if (typeof window !== 'undefined') {
        return window.innerWidth < 768;
      }
      return true;
    },
  },
  methods: {
    ...mapActions(['setToggle']),
    onInputPuzzle(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getPuzzles(name);
      }, 500);
    },
    getPuzzles(params) {
      CrosswordsService.getPuzzles(params, 'palavra-criptograma')
        .then(response => {
          this.puzzles = response.data;
        })
        .catch(error => {
          if (error && error.response && error.response.status === 401) {
            this.setToggle({ type: 'login_modal', bool: true });
          }
        });
    },
    setPuzzle(puzzle) {
      this.model.data = {
        name: puzzle.name,
        rows: puzzle.rows,
        table: puzzle.table,
        columns: puzzle.columns,
        settings: puzzle.settings,
      };
      this.$emit('update:model', this.model);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/cryptogram";
</style>
